<template>
    <div class="turnstile-wrapper">
        <div ref="widgetContainer"></div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps, defineEmits, defineExpose } from 'vue'

const props = defineProps({
    // 替换为 Cloudflare 控制台获取的 Sitekey（测试 Key 可用: 1x00000000000000000000AA）
    sitekey: {
        type: String,
        default: '1x00000000000000000000AA'
    },
    theme: {
        type: String,
        default: 'auto' // 'light' | 'dark' | 'auto'
    }
})

const emit = defineEmits(['verify', 'expire', 'error'])

const widgetContainer = ref(null)
let widgetId = null

// 初始化 Turnstile 挂载
const renderTurnstile = () => {
    if (window.turnstile && widgetContainer.value) {
        widgetId = window.turnstile.render(widgetContainer.value, {
            sitekey: props.sitekey,
            theme: props.theme,
            callback: (token) => {
                emit('verify', token)
            },
            'expired-callback': () => {
                emit('expire')
            },
            'error-callback': () => {
                emit('error')
            }
        })
    }
}

// 供父组件在提交失败或需要重置时调用
const reset = () => {
    if (window.turnstile && widgetId !== null) {
        window.turnstile.reset(widgetId)
    }
}

defineExpose({ reset })

onMounted(() => {
    // 防止脚本未加载完成时调用报错
    if (window.turnstile) {
        renderTurnstile()
    } else {
        const timer = setInterval(() => {
            if (window.turnstile) {
                clearInterval(timer)
                renderTurnstile()
            }
        }, 100)
    }
})

onBeforeUnmount(() => {
    if (window.turnstile && widgetId !== null) {
        window.turnstile.remove(widgetId)
    }
})
</script>

<style scoped>
.turnstile-wrapper {
    display: flex;
    justify-content: center;
    margin: 15px 0;
}
</style>